import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormFields } from '@epi-forms/helpers';
import { BenefitType, ON_HOLD } from '@epi-constants/benefitTypes';
import { employeesPerPage } from '@epi-constants/topupEmployees';
import { useGetMetadataQuery } from '@epi-api/companyMetadata';

export const useTopupSwitch = () => {
  const [isToggle, setIsToggle] = useState(true);
  const [showOnHoldBtn, setShowOnHoldBtn] = useState(false);

  const { watch, setValue } = useFormContext();

  const { data: companyMetadata } = useGetMetadataQuery(undefined, {
    refetchOnMountOrArgChange: false
  });

  const checkableEmployees = watch(FormFields.CheckableEmployees);
  const benefitType = watch(FormFields.Benefit);

  const isOnHoldEmployee = !!checkableEmployees.find(
    employee => employee.employmentType === ON_HOLD
  );

  const handleToggler = () => {
    setValue(
      FormFields.CheckableEmployees,
      checkableEmployees.map(elem =>
        elem.onHold ? { ...elem, isChecked: !isToggle } : { ...elem }
      )
    );

    setIsToggle(prevState => !prevState);
  };

  useEffect(() => {
    if (companyMetadata) {
      setIsToggle(companyMetadata.showOnHoldBeneficiaries);
    }
  }, [companyMetadata]);

  useEffect(() => {
    const employeesOnHold = checkableEmployees.filter(
      employee => employee.employmentType === ON_HOLD && employee
    );

    const atLastOneChecked = employeesOnHold.filter(emp => emp.isChecked);
    if (employeesOnHold.length) {
      if (atLastOneChecked.length) {
        setIsToggle(true);
      } else {
        setIsToggle(false);
      }
    } else {
      setIsToggle(false);
    }
  }, [checkableEmployees]);

  useEffect(() => {
    const paginationCount = Math.ceil(
      checkableEmployees.length / employeesPerPage
    );

    if (
      (benefitType === BenefitType.Massage ||
        benefitType === BenefitType.Wellbeing ||
        benefitType === BenefitType.Recreational) &&
      isOnHoldEmployee &&
      !!paginationCount
    ) {
      setShowOnHoldBtn(true);
    } else {
      setShowOnHoldBtn(false);
    }
  }, [benefitType, isOnHoldEmployee]);

  return { handleToggler, isToggle, showOnHoldBtn };
};
